import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import {useDispatch} from 'react-redux';
import _ from 'lodash';
import clsx from 'clsx';
import {getPatientReviewStatus} from '../../../../../../../store/reducers/reviews';
import {ED_REVIEW_PATIENT_STATUSES} from '../../../utils/edReviewUtils';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  divRow: {
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'row',
    alignItems: 'center',
  },
  reviewStatus: {
    gap: 10,
    alignItems: 'center',

    '&.notRegistered, &.cancelled, &.notAssigned': {
      color: theme.palette.error.main
    },
    "&.registered": {
      color: '#F7A202'
    },
    "&.inReview": {
      color: '#4EAC6F'
    },
  },
  dot: {
    width: 10,
    height: 10,
    marginBottom: 2,
    borderRadius: '50%',
    backgroundColor: 'black',

    "&.notRegistered, &.cancelled, &.notAssigned": {
      backgroundColor: theme.palette.error.main
    },
    "&.registered": {
      backgroundColor: '#F7A202'
    },
    "&.inReview": {
      backgroundColor: '#4EAC6F'
    }
  },
}));

const EdReviewStatus = ({ hospitalNumber, statusClasses, patient }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const reviewStatus = dispatch(getPatientReviewStatus(hospitalNumber, patient));

  const printStatus = useCallback((revStatus) => {
    switch (revStatus) {
      case ED_REVIEW_PATIENT_STATUSES.REGISTERED:
      case ED_REVIEW_PATIENT_STATUSES.CANCELLED:
        return _.capitalize(revStatus);
      case ED_REVIEW_PATIENT_STATUSES.UNREGISTERED:
        return "Not Registered";
      case ED_REVIEW_PATIENT_STATUSES.NOT_ASSIGNED:
        return "Not Assigned";
      case ED_REVIEW_PATIENT_STATUSES.IN_REVIEW:
        return "In Review";
      default:
        return;
    }
  }, []);

  return reviewStatus && (
    <div className={clsx(classes.divRow, classes.reviewStatus, reviewStatus, statusClasses && statusClasses)}>
      <div className={clsx(classes.dot, reviewStatus)} />

      {printStatus(reviewStatus)}
    </div>
  );
};

EdReviewStatus.propTypes = {
  patient: PropTypes.object,
  hospitalNumber: PropTypes.string,
  statusClasses: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
};

EdReviewStatus.defaultProps = {
  patient: null,
  hospitalNumber: '',
  statusClasses: null,
};

export default EdReviewStatus;